import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/solid'
import { FC } from 'react'

type Props = {
  description?: string
}

const RequestDescription: FC<Props> = ({ description }) => {
  if (!description) {
    return null
  }

  return (
    <div className="flex items-center gap-x-1 text-grey-60 sm:items-start">
      <ChatBubbleBottomCenterTextIcon
        data-testid="request-description-icon-id"
        className="mr-8 h-20 w-20 flex-shrink-0"
      />
      <span className="overflow-hidden text-ellipsis whitespace-nowrap text-16 sm:line-clamp-2 sm:whitespace-normal sm:break-words sm:text-14">
        {description}
      </span>
    </div>
  )
}

export { RequestDescription }
